.page {
  --docs-page-gutter: clamp(1.25rem, 4vw, 4.5rem);

  position: relative;
  container-name: doc-page;
  container-type: inline-size;
  min-width: 0;
  max-width: none;
  gap: 1.25rem;
  padding: clamp(2.5rem, 5vw, 5rem) var(--docs-page-gutter) 6rem;
}

// The article's width in the docs layout; its prose styles are Article's
// (src/components/common/Article/Article.module.scss). `--docs-page-bleed` is the distance from
// the article's edge to the page's, for content that runs edge to edge (the features carousel).
.page :global(article) {
  --docs-page-bleed: calc((100cqi - min(100cqi, 58rem)) / 2 + var(--docs-page-gutter));

  width: min(100%, 58rem);
  margin-inline: auto;
}

.embedded {
  padding: 1.5rem;
}

.embedded :global(article) {
  width: 100%;
}

@media (max-width: 700px) {
  .page {
    --docs-page-gutter: 1rem;

    padding: 2rem var(--docs-page-gutter) 4rem;
  }
}
